import { render, staticRenderFns } from "./CmfStep3.vue?vue&type=template&id=07def482&scoped=true"
import script from "./CmfStep3.vue?vue&type=script&lang=js"
export * from "./CmfStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07def482",
  null
  
)

export default component.exports